import errorIcon from "../../assets/img/error.png";
import {PrimaryButton} from "../button";
import refreshIcon from "../../assets/img/refresh.png"
import { useViewContext } from "../../contexts/view.context";

const ErrorView = ({ errMssg }) => {
  const {view, setView} = useViewContext();
  return (
    <div className="errorView">
      <div className="mt-5 flex w-full justify-center">
        <img src={errorIcon} alt="Error Icon"/>
      </div>
      <p className="mt-5 text-center">
       {errMssg}
      </p>

      <div className="mt-5">
        <PrimaryButton text="Try Another Card" className="w-full mb-5 p-1 rounded-lg" onClick={() => setView("card")} id="another-card"/>
        <PrimaryButton text="Try Paying With Transfer" className="w-full mb-5 p-1 rounded-lg" onClick={() => setView("transfer")} id="pay-transfer"/>
      </div>
      <div className="flex justify-center">
        <img src={refreshIcon} alt="refresh-icon"/>
        <h6 onClick={() => setView("card")}>Retry Payment</h6>
      </div>
    </div>
  );
};

export default ErrorView;
